import { render, staticRenderFns } from "./GuppyChatMessageFooter.vue?vue&type=template&id=b9137b02&"
import script from "./GuppyChatMessageFooter.vue?vue&type=script&lang=js&"
export * from "./GuppyChatMessageFooter.vue?vue&type=script&lang=js&"
import style0 from "./GuppyChatMessageFooter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports